import { motion } from "framer-motion";
import { Search, ShoppingCart, Truck } from "lucide-react";

const steps = [
  {
    number: "01",
    title: "Browse Products",
    description:
      "Explore our healthcare equipment and find the right solution for your needs.",
    icon: Search,
  },

  {
    number: "02",
    title: "Place Your Order",
    description:
      "Add products to your cart and complete your order with simple checkout.",
    icon: ShoppingCart,
  },

  {
    number: "03",
    title: "Receive Delivery",
    description: "Get your equipment delivered safely and conveniently.",
    icon: Truck,
  },
];

const HowItWorksSection = () => {
  return (
    <section
      className="
py-20
bg-gray-50
"
    >
      <div
        className="
max-w-7xl
mx-auto
px-6
"
      >
        {/* Heading */}

        <motion.div
          initial={{
            opacity: 0,
            y: 30,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.6,
          }}
          viewport={{
            once: true,
          }}
          className="
text-center
mb-12
"
        >
          <h2
            className="
text-3xl
md:text-4xl
font-bold
text-gray-900
"
          >
            How It Works
          </h2>

          <p
            className="
mt-4
text-gray-600
"
          >
            Getting the healthcare equipment you need is simple and convenient.
          </p>
        </motion.div>

        {/* Steps */}

        <div
          className="
grid
grid-cols-1
md:grid-cols-3
gap-8
relative
"
        >
          {steps.map((step, index) => {
            const Icon = step.icon;

            return (
              <motion.div
                key={index}
                initial={{
                  opacity: 0,
                  y: 40,
                }}
                whileInView={{
                  opacity: 1,
                  y: 0,
                }}
                transition={{
                  duration: 0.5,
                  delay: index * 0.15,
                }}
                viewport={{
                  once: true,
                }}
                className="
text-center
"
              >
                <div
                  className="
relative
mx-auto
w-20
h-20
rounded-full
bg-green-100
flex
items-center
justify-center
"
                >
                  <Icon
                    size={35}
                    className="
text-green-600
"
                  />

                  <span
                    className="
absolute
-top-2
-right-2
bg-green-600
text-white
text-xs
w-7
h-7
rounded-full
flex
items-center
justify-center
font-bold
"
                  >
                    {step.number}
                  </span>
                </div>

                <h3
                  className="
mt-6
text-xl
font-semibold
text-gray-900
"
                >
                  {step.title}
                </h3>

                <p
                  className="
mt-3
text-gray-600
leading-relaxed
max-w-sm
mx-auto
"
                >
                  {step.description}
                </p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection;
